<template>
    <div class="product-showcase">
        <transition-group name="product-showcase-transition" tag="figure">
            <product-image
                v-for="(image, idx) in images"
                v-show="showProductAtIndex(idx)"
                :key="'image' + idx"
                :image="image">
            </product-image>
        </transition-group>
    </div>
</template>

<script src="./product-showcase.js"></script>
